/* eslint-disable class-methods-use-this, lines-between-class-members */

class SPMini {
  config = {};
  iframe = null;
  handleEvents = () => {};
  buttons = [];

  init(elId, config) {
    this.config = config;
    this.iframe = this.prepareIframe(elId);
    this.handleEvents = config.handleEvents;
    this.buttons = config.buttons || [];
    this.loadScripts();
  }

  getBaseUrl() {
    let url = process.env.MIX_ASSET_URL;

    if (process.env.MIX_NGROK_DEV_ENABLED === 'true') {
      url = `https://${process.env.MIX_NGROK_DEV_SUBDOMAIN}.${process.env.MIX_NGROK_DEV_APP_DOMAIN}`;
    }

    return url;
  }

  loadScripts() {
    const scriptEl = document.createElement('script');
    scriptEl.setAttribute('type', 'text/javascript');
    scriptEl.setAttribute('src', `${this.getBaseUrl()}/js/iframeResizer.min.js`);
    document.head.appendChild(scriptEl);

    scriptEl.addEventListener('load', () => {
      // eslint-disable-next-line no-undef
      iFrameResize({
        log: false,
        heightCalculationMethod: 'lowestElement',
        maxHeight: this.config.integrationId === 'wordpress' ? 'calc(100% - 5px)' : 'calc(100vh - 5px)',
      }, '#stockpress-mini iframe');
    });
  }

  getIframeParams() {
    const iframeParams = new URLSearchParams();
    iframeParams.append('integrationId', this.config.integrationId);
    Object.keys(this.config).forEach((key) => {
      if (key.indexOf(this.config.integrationId) === 0) {
        iframeParams.append(key, this.config[key]);
      }
    });
    if (this.config.authToken) {
      iframeParams.append('authToken', this.config.authToken);
    }
    if (this.config.externalUserToken) {
      iframeParams.append('externalUserToken', this.config.externalUserToken);
    }
    return iframeParams.toString();
  }

  getIframeUrl() {
    return `${this.getBaseUrl()}/embed/?${this.getIframeParams()}`;
  }

  prepareIframe(elId) {
    const iframe = document.createElement('iframe');
    iframe.name = 'stockpress-mini';
    iframe.src = this.getIframeUrl();
    iframe.style.width = '100%';
    iframe.style.height = '100vh';
    iframe.style.border = 'none';
    iframe.onload = () => {
      this.sendMessage('config', this.config);
    };
    document.getElementById(elId).appendChild(iframe);
    return window.frames['stockpress-mini'];
  }

  sendMessage(event, data) {
    this.iframe.postMessage({
      source: 'spmini',
      event,
      data: JSON.parse(JSON.stringify(data)),
    }, '*');
  }
}

window.addEventListener('message', async (message) => {
  const {
    source,
    event,
    data,
  } = message.data;

  if (source !== 'spmini') {
    return;
  }

  window.SPMini.handleEvents(event, data);
});

window.SPMini = new SPMini();
